import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

/**
 * Visor en popup (con flechas si hay varios) para los comprobantes (foto o PDF) adjuntos a
 * los cobros manuales — antes se abrían en una pestaña nueva. Mismo patrón que
 * visit_controller.ts#openPhotoPreview, generalizado para aceptar también PDF (vía iframe) y
 * reutilizando un único modal/carousel estático definido en _mensualidades_tab.html.twig.
 */
export default class extends Controller {

    open(e: Event): void {
        e.preventDefault();
        const clicked = (e.currentTarget as HTMLElement);

        const items = Array.from(this.element.querySelectorAll<HTMLElement>('[data-cobro-comprobante-src]'));
        if (items.length === 0) return;

        const attachments = items.map((el) => ({
            url: el.dataset.cobroComprobanteSrc as string,
            type: el.dataset.cobroComprobanteType || 'image',
        }));
        let activeIndex = items.indexOf(clicked);
        if (activeIndex === -1) activeIndex = 0;

        const carouselInner = document.getElementById('cobroComprobanteCarouselInner');
        const counter = document.getElementById('cobroComprobanteCounter');
        if (!carouselInner) return;

        carouselInner.innerHTML = attachments.map((a, i) => {
            const active = i === activeIndex ? ' active' : '';
            const body = a.type === 'pdf'
                ? `<iframe src="${this.esc(a.url)}" class="w-100 border-0 bg-white" style="height:80vh;"></iframe>`
                : `<img src="${this.esc(a.url)}" class="d-block mx-auto img-fluid" style="max-height:80vh;">`;
            return `<div class="carousel-item${active}">${body}</div>`;
        }).join('');

        if (counter) {
            counter.textContent = attachments.length > 1 ? `${activeIndex + 1} / ${attachments.length}` : '';
        }

        const carouselEl = document.getElementById('cobroComprobanteCarousel');
        if (carouselEl && attachments.length > 1) {
            carouselEl.addEventListener('slid.bs.carousel', (event: any) => {
                if (counter) counter.textContent = `${event.to + 1} / ${attachments.length}`;
            });
        }

        const controls = carouselEl?.querySelectorAll('.carousel-control-prev, .carousel-control-next');
        controls?.forEach((ctrl) => {
            (ctrl as HTMLElement).style.display = attachments.length > 1 ? '' : 'none';
        });

        const modalEl = document.getElementById('cobroComprobanteModal');
        if (modalEl) {
            // El modal de historial (modal-form_controller.ts) se mueve a document.body y
            // queda como último hijo — con el mismo z-index de Bootstrap, el orden en el DOM
            // decide quién pinta encima. appendChild sobre un nodo ya existente lo MUEVE (no
            // lo clona), así que esto garantiza que este modal quede siempre por encima del de
            // historial, sin importar dónde se haya renderizado originalmente en la página.
            document.body.appendChild(modalEl);
            Modal.getOrCreateInstance(modalEl).show();
        }
    }

    private esc(value: string): string {
        return value
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }
}
